import { ExerciseMaterial } from "./exercise-material.model";

export class Exercise {
    id?: number;
    number?: number;
    description?: string;
    materials: ExerciseMaterial[] = [];

    static fromJson(fields: any): Exercise {
        let item = Object.assign(new this(), fields);
        item.videos = fields?.videos?.map((item: any) => ExerciseMaterial.fromJson(item));
        return item;
    }
}
